import { type RefObject, useId } from 'react';
import Card from '@rio-cloud/rio-uikit/Card';
import { DriverChatUpsellingButton } from './DriverChatUpsellingButton';
import { useDriverChatMessages } from './useDriverChatMessages';

type Props = {
    viewRef: RefObject<HTMLDivElement | null>;
    trackingCategory: string;
};

export const CampaignCView = ({ viewRef, trackingCategory }: Props) => {
    const titleId = useId();
    const { message } = useDriverChatMessages();

    return (
        <div ref={viewRef} className='height-100pct overflow-y-auto bg-white padding-x-20 padding-y-25'>
            <Card className='max-width-350 margin-auto border-none' padding={0} shadow='none'>
                <section aria-labelledby={titleId} className='display-flex flex-column gap-10'>
                    <header className='text-center display-flex flex-column gap-10'>
                        <div className='display-flex flex-column align-items-center'>
                            <div className='display-flex align-items-center' aria-hidden='true'>
                                <span className='uikit-icon icon-chat text-size-h3 text-color-primary' />
                                <span className='uikit-icon icon-arrows-horizontal text-size-16 text-color-dark' />
                                <span className='uikit-icon icon-language text-size-h3 text-color-secondary' />
                            </div>
                        </div>
                        <div className='text-center max-width-600 margin-auto'>
                            <h1
                                id={titleId}
                                className='text-size-h3 text-wrap-balance text-color-darkest margin-0'
                                style={{ textTransform: 'none', fontWeight: 400, lineHeight: 'inherit' }}
                            >
                                Driver Chat
                            </h1>
                            <p className='text-size-14 text-wrap-balance line-height-125rel text-color-dark margin-bottom-0 margin-top-5'>
                                {message('intro')}
                            </p>
                        </div>
                    </header>
                    <div className='display-flex flex-column gap-10 margin-top-10 margin-bottom-10'>
                        <div className='bg-lightest rounded padding-15 display-flex gap-15'>
                            <span className='uikit-icon icon-chat text-size-h2 text-color-primary' aria-hidden='true' />
                            <div>
                                <h2
                                    className='text-size-16 text-wrap-balance text-medium text-color-darkest margin-0'
                                    style={{ lineHeight: 'inherit' }}
                                >
                                    {message('communication.title')}
                                </h2>
                                <p className='text-wrap-balance text-color-dark margin-bottom-0 margin-top-5'>
                                    {message('communication.description')}
                                </p>
                            </div>
                        </div>
                        <div className='bg-lightest rounded padding-15 display-flex gap-10'>
                            <span
                                className='uikit-icon icon-delivery text-size-h2 text-color-primary'
                                aria-hidden='true'
                            />
                            <div>
                                <h2
                                    className='text-size-16 text-wrap-balance text-medium text-color-darkest margin-0'
                                    style={{ lineHeight: 'inherit' }}
                                >
                                    {message('orders.title')}
                                </h2>
                                <p className='text-wrap-balance text-color-dark margin-bottom-0 margin-top-5'>
                                    {message('orders.description')}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='text-center'>
                        <DriverChatUpsellingButton trackingCategory={trackingCategory} withArrow />
                    </div>
                </section>
            </Card>
        </div>
    );
};
